

import React from 'react'
// import { Link } from 'react-router-dom'
// import { Outlet } from 'react-router-dom'
export default function About() {
 
    
    return <>
  
     
   
  
  <h2>about</h2>
  
  
  
  
  
  
    </>
}
